import request from '@/utils/request'


// 查询用户消息列表
export function listMsg(query) {
  return request({
    url: '/user/user-msg/list',
    method: 'get',
    params: query
  })
}

// 查询用户消息分页
export function pageMsg(query) {
  return request({
    url: '/user/user-msg/page',
    method: 'get',
    params: query
  })
}

// 查询用户消息详细
export function getMsg(data) {
  return request({
    url: '/user/user-msg/detail',
    method: 'get',
    params: data
  })
}

// 新增用户消息
export function addMsg(data) {
  return request({
    url: '/user/user-msg/add',
    method: 'post',
    data: data
  })
}

// 修改用户消息
export function updateMsg(data) {
  return request({
    url: '/user/user-msg/edit',
    method: 'post',
    data: data
  })
}

// 删除用户消息
export function delMsg(data) {
  return request({
    url: '/user/user-msg/delete',
    method: 'post',
    data: data
  })
}
